// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1SG7c","bigColWidth":"Table_bigColWidth__3u6Fy","biggerColWidth":"Table_biggerColWidth__2qvLs","row":"Table_row__2bBNK","col":"Table_col__3n_Zp"};